import { Input } from 'antd';
import { useEffect, useState } from 'react';

export const TeamFilters = ({
  initialFilters,
  updateQueryParams,
}: {
  initialFilters?: string;
  updateQueryParams: (term: string) => void;
}) => {
  const [searchTerm, setSearchTerm] = useState(initialFilters || '');

  useEffect(() => {
    if (initialFilters !== searchTerm) {
      setSearchTerm(initialFilters || '');
    }
  }, [initialFilters]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    updateQueryParams(e.target.value);
    setSearchTerm(e.target.value);
  };

  return (
    <Input
      className="w-full px-3"
      allowClear
      placeholder="Search teams by name or team ID"
      value={searchTerm}
      onChange={handleChange}
    />
  );
};
